/**
 * Indicators reducer, gotta do some fancy magic here
 * @param  {object} acc          routing state
 * @param  {object} payload      action payload
 * @param  {object} routingState current routing state
 * @return {object}              new routing state
 */
export default function indicators(acc, payload, routingState) {
  const newVal = `${payload}`;
  const routingVal = (
    routingState.indicators &&
    (Array.isArray(routingState.indicators) ?
      routingState.indicators :
      [routingState.indicators])
  ) || [];

  // Clean up the routing state IF the indicator exsits
  // This is pretty hacky (yes I hate it) but I don't
  // have time to impliment a better solution, this only works
  // because javascript passes everything by reference...
  if (routingVal.indexOf(newVal) &&
    Object.hasOwnProperty.call(routingState, newVal)
  ) {
    delete routingState[newVal]; // eslint-disable-line no-param-reassign
  }

  // Simple toggle check
  return {
    ...acc,
    indicators: (-1 !== routingVal.indexOf(newVal) ?
      routingVal.filter((vals) => vals !== newVal) :
      routingVal.concat(newVal)
    ),
  };
}



// WEBPACK FOOTER //
// ./app/middleware/router/indicators.js